import React from 'react';
import _ from 'lodash';

export default class TechnicalInformationCardIssuesListItem extends React.Component {

    getWarnings = () => this.props.item.items.map(x => x.field.warning);

    render() {
        let groups = _.groupBy(this.getWarnings(), 'type');

        return (
            <React.Fragment>
                {this.renderGroup(groups[0], 'force-to-change')}
                {this.renderGroup(groups[1], 'warning')}
            </React.Fragment>
        )
    }

    renderGroup = (group, className) => {
        if (!group) {
            return <React.Fragment/>
        }

        return (<div className={'configuration-editor-issues-list-item ' + className} onClick={this.props.onClick}>
            <strong>{this.props.item.step.getTranslatedName()}</strong>: {group.length} {__('issues')}
        </div>)
    }
}